// Phase 7 — Track B T-B4. Preferences form validation.
//
// Mirrors the backend's `updatePreferencesBodySchema` and
// `updateTimezoneBodySchema` in `src/core/users/preferences/schemas.ts`
// (delivered in D1 / Track A). Phase 7 Q-12 locked per-alert-type
// granularity, so `notifications` is a string→boolean map keyed by
// alert_type_id slug (e.g. `payments.due_soon`).
//
// Q-14 locked the IANA timezone identifier as the storage shape; the
// backend deliberately stays lenient on the value (regex on the character
// class only) and the SPA picks a value from `Intl.supportedValuesOf('timeZone')`.

import { z } from 'zod';

export const themeSchema = z.enum(['light', 'dark', 'system']);
export type Theme = z.infer<typeof themeSchema>;

export const notificationsMapSchema = z.record(z.string().min(1), z.boolean());
export type NotificationsMap = z.infer<typeof notificationsMapSchema>;

export const updatePreferencesBodySchema = z
  .object({
    theme: themeSchema.optional(),
    notifications: notificationsMapSchema.optional(),
  })
  .strict()
  .refine((v) => Object.keys(v).length > 0, {
    message: 'patch must contain at least one field',
  });

export type UpdatePreferencesBody = z.infer<typeof updatePreferencesBodySchema>;

export const updateTimezoneBodySchema = z
  .object({
    timezone: z
      .string()
      .min(1)
      .max(100)
      .regex(/^[A-Za-z0-9_+\-/]+$/, 'invalid timezone identifier'),
  })
  .strict();

export type UpdateTimezoneBody = z.infer<typeof updateTimezoneBodySchema>;
